// Presentation flags and numeric padding must not make a loaded order dirty.
// Keep missing values distinct from zero (especially optional purchase prices).
const numericValue = (value) => {
  if (value == null || String(value).trim() === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : String(value);
};

export const orderHeaderSignature = (form = {}) => JSON.stringify([
  form.expected_delivery_date || "",
  numericValue(form.destination_location_id),
  form.notes || "",
]);

export const orderLineSignature = (line = {}) => JSON.stringify([
  numericValue(line.item_id),
  numericValue(line.unit_id),
  numericValue(line.quantity),
  numericValue(line.unit_price),
  numericValue(line.destination_location_id),
]);

export const hasOrderEditorChanges = (form) => Boolean(form && (
  form.__savedHeader !== orderHeaderSignature(form)
  || form.removedLineIds?.length
  || form.lines?.some((line) => !line.id || line.__isNew
    || line.__savedSignature !== orderLineSignature(line))
));
